<template>
<v-card outlined tile>
    <v-card-text>
        <v-form ref="form" style="width: 100%" v-model="valid">
            <div class="d-flex align-center flex-wrap">
                <div class="mr-3">
                    <DateRangeInput v-model="fields.daterange" @change="changed('daterange', $event)" label="Rango de Fechas" :disabled="loading"/>
                </div>
                <template v-if="context == 'sistema'">
                    <SelectorSistema v-model="fields.sistema_id" :params="{ sistema_type_slug: sistema_type }" :disabled="loading" class="mr-3"/>
                </template>
                <template v-else>
                    <SelectorMaster
                        v-model="fields.master_id"
                        :disabled="loading"
                        @change="changed('master_id', $event)"
                        class="mr-3"
                        />
                    <SelectorComercializadora
                        v-model="fields.comercializadora_id"
                        :disabled="loading  || !this.fields.master_id"
                        :params="{ master_id: fields.master_id }"
                        needs-parent-to-load
                        @change="changed('comercializadora_id', $event)"
                        class="mr-3"
                        />
                    <SelectorGrupo
                        v-model="fields.grupo_id"
                        :disabled="loading  || !this.fields.comercializadora_id"
                        :params="{ comercializadora_id: fields.comercializadora_id }"
                        needs-parent-to-load
                        @change="changed('grupo_id', $event)"
                        class="mr-3"
                        />
                    <SelectorTaquilla
                        v-model="fields.taquilla_id"
                        :disabled="loading  || !this.fields.grupo_id"
                        :params="{ grupo_id: fields.grupo_id }"
                        needs-parent-to-load
                        @change="changed('taquilla_id', $event)"
                        class="mr-3"
                        />
                </template>
            </div>
        </v-form>
    </v-card-text>
    <v-divider/>
    <v-card-actions class="flex-wrap">
        <v-card class="mr-2" tile outlined>
            <div class="ml-1 mb-1 mr-2">
                <v-checkbox 
                    v-model="fields.consolidado" 
                    label="Consolidar Por Divisa"
                    hide-details
                    class="ma-0"
                    dense
                    :disabled="loading"
                    />
            </div>
            <v-divider class="mb-2" v-if="fields.consolidado"/>
            <div class="ml-2 mb-1" v-if="fields.consolidado">
                <SelectorDivisaChip v-model="fields.divisaList" :disabled="loading"/>
            </div>
        </v-card>
        <v-card tile outlined v-if="canShowCompare">
            <v-checkbox 
                v-model="fields.compare" 
                label="Comparar con periodo anterior"
                hide-details
                class="ma-0 ml-1 mb-1 mr-2"
                dense
                :disabled="loading"
                />
        </v-card>
        <v-spacer/>
        <v-btn text class="mr-1" :disabled="loading" @click="reset()">Reiniciar Filtros</v-btn>
        <v-btn color="primary" :disabled="loading" :loading="loading" @click="search()"><v-icon>mdi-magnify</v-icon>Buscar</v-btn>
    </v-card-actions>
</v-card>
</template>

<script>
import Search from '@mixins/search';

export default {
    components: {
        
    },
    props: {
        context: { default: 'comercio' }, 
        value: {}, 
        loading: { default: false },
        sistema_type: { default: 'sistema' },
    },
    mixins: [Search],
    data: function ()  {
        return {
            defaultFields: {
                daterange: [this.$luxon.local().toISODate(), this.$luxon.local().toISODate()],
                master_id: null,
                comercializadora_id: null,
                grupo_id: null,
                taquilla_id: null,
                sistema_id: null,
                compare: false,
                consolidado: false,
                divisaList: [],
            },
        }
    },
    computed: {
        user: function () {
            return this.$store.getters['persist/auth/user'];
        },
        canShowCompare: function () {
            return this.user.domain?.slug == 'operadora';
        }
    },
    methods: {
        onChange: function (field) {
            switch(field) {
                case 'master_id':
                    this.fields.comercializadora_id = null;   
                break;
                case 'comercializadora_id':
                    this.fields.grupo_id = null;   
                break;
                case 'grupo_id':
                    this.fields.taquilla_id = null;   
                break;
            }
        }
    },
}
</script>

<style>

</style>